<script lang="ts">
  import { fade } from "svelte/transition";

  import { useTranslations } from "@/i18n";
  import type { AccessRankingResponseBody } from "@/types/api/accessRanking";
  import type { LangType } from "@/types/i18n";

  export let lang: LangType;
  const { t } = useTranslations(lang);

  const fetchRankingData = async (): Promise<AccessRankingResponseBody> =>
    await fetch(
      `${window.location.origin}/api/access-ranking-${lang}.json`,
    ).then((res) => {
      if (!res.ok) {
        throw new Error("Failed to fetch access ranking data");
      }
      return res.json();
    });
</script>

{#await fetchRankingData() then rankingData}
  <div
    in:fade
    id="ranking-container"
    class="post_content_side_inner post_content_side_inner--event-ranking"
  >
    <h4
      class="post_content_side_inner_title"
      style="background-color: #ccc; text-indent: 0.5em;"
    >
      {t("accessRanking.title")}
    </h4>
    <ul id="ranking-list">
      {#each rankingData.topics as topic, i}
        <li class="ranking-list_item">
          <a href={topic.url}>
            <span class={`ranking-list_icon ranking-list_icon--${i + 1}`}>
              {i + 1}
            </span>
            <div class="ranking-list_item_inner">
              <h5 class="ranking-list_item_inner_sub-title">{topic.title}</h5>
              <span class="ranking-list_item_cat">{topic.group}</span>
            </div>
          </a>
        </li>
      {/each}
    </ul>
  </div>
{/await}
